import {
  Button,
  ButtonGroup,
  Content,
  Dialog,
  Divider,
  // Form,
  Heading,
  // TextField,
  useDialogContainer,
  Flex,
  RadioGroup,
  Radio,
} from "@adobe/react-spectrum";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useOktaAuth } from "@okta/okta-react";
import { error as ErrorToast } from "@react/react-spectrum/Toast";
import { bulkChangesApi } from "../../../../api/bulkChangesApi";

export default function DownloadParentSubsDialog({
  downloadRequest,
  setPageLoading,
  isPageLoading,
}) {
  const dialog = useDialogContainer();
  const { authState } = useOktaAuth();

  const [selectedExportType, setSelectedExportType] = useState("full");

  const fullExportRequest = {
    search_string: "",
    sub_name: "",
    sub_id: "",
    domain: "",
    duns_number: "",
    status: downloadRequest?.status,
    page_no: 1,
    page_size: 1000,
    sort_options: [
      {
        field_name: "parent_id",
        sort_order: 1,
      },
    ],
  };

  const sampleExportRequest = {
    search_string: "",
    sub_name: "",
    sub_id: "",
    domain: "",
    duns_number: "",
    status: ["sample-import"],
    sort_options: [
      {
        field_name: "parent_id",
        sort_order: 1,
      },
    ],
  };

  // Function to convert Blob to string
  const convertBlobToString = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsText(blob);
    });

  // Function to parse CSV string into array of rows
  const parseCSVString = (csvString) =>
    csvString.split("\n").map((row) => row.split(","));

  // Function to replace commas with another delimiter
  const replaceCommas = (rows, delimiter) =>
    rows.map((row) => row.map((cell) => cell.replace(/,/g, delimiter)));

  // Function to generate CSV content from rows
  const generateCSVContent = (rows) =>
    rows.map((row) => row.join(",")).join("\n");

  const handleExport = () => {
    let exportRequest = downloadRequest;
    if (selectedExportType === "full") exportRequest = fullExportRequest;
    if (selectedExportType === "sample") exportRequest = sampleExportRequest;
    setPageLoading(true);
    bulkChangesApi
      .exportGTMHFile(
        {
          ...exportRequest,
          ...(selectedExportType !== "sample" && { page_size: 100000000 }),
        },
        authState.accessToken
      )
      .then((data) => {
        dialog.dismiss();
        setPageLoading(false);
        const fileName = "gtmh_sub_export.csv";

        // Assuming you have your Blob object named byteArrayBlob
        convertBlobToString(data)
          .then((csvString) => {
            const csvRows = parseCSVString(csvString);
            const modifiedRows = replaceCommas(csvRows, "\t"); // Using tab as delimiter
            const csvContent = generateCSVContent(modifiedRows);

            // Download CSV file
            const url = window.URL.createObjectURL(
              new Blob([csvContent], { type: "text/csv" })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            console.error("Error reading Blob:", error);
          });
      })
      .catch((e) => {
        ErrorToast(
          e.response?.data?.message || "Error exporting file, please try again",
          { timeout: 2000 }
        );
        dialog.dismiss();
        setPageLoading(false);
      });
  };

  const handleCancel = () => {
    dialog.dismiss();
  };

  return (
    <Dialog>
      <Heading>Export Data</Heading>
      <Divider />
      <Content>
        {/* <Form labelPosition="side" width="100%">
            <TextField autoFocus label="Name" onChange={setNodeName} isRequired />
            <TextField autoFocus label="Duns ID" onChange={setDunsId} />
          </Form> */}
        <RadioGroup
          defaultValue="full"
          value={selectedExportType}
          onChange={setSelectedExportType}
        >
          <Radio value="full">Full Export</Radio>
          <Radio value="partial">Search Results Export</Radio>
          <Radio value="sample">Sample Import File</Radio>
        </RadioGroup>
        <Flex direction="column" alignItems="end">
          <ButtonGroup>
            <Button onPress={handleCancel} variant="secondary">
              Cancel
            </Button>
            <Button
              onPress={handleExport}
              color="primary"
              variant="accent"
              isDisabled={isPageLoading}
            >
              Export
            </Button>
          </ButtonGroup>
        </Flex>
      </Content>
    </Dialog>
  );
}

DownloadParentSubsDialog.propTypes = {
  downloadRequest: PropTypes.objectOf(
    PropTypes.oneOfType(
      PropTypes.string,
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.any)
    )
  ).isRequired,
  setPageLoading: PropTypes.func.isRequired,
  isPageLoading: PropTypes.bool.isRequired,
};
